import React, { ReactNode } from "react";


interface ProjectIconButtonProps {
  label: string; 
  icon: ReactNode;
}

const ProjectIconButton: React.FC<ProjectIconButtonProps> = ({label, icon}) => {
  return (
    <button className="flex items-center justify-between bg-rajapiGreen text-white rounded-2xl px-2 py-2 mr-7">
      <div className="bg-white p-3 rounded-xl mr-3">
        {icon}
      </div>
      <span className="mr-2">
        {label}
      </span>
    </button>
  );
};

export default ProjectIconButton;
